export default __webpack_public_path__ + "static/media/pesto.00fe77dd.png";